<template>
    <div>
        <v-alert v-if="itemData"
            border="left"
            colored-border
            :color="alertColor"
            elevation="2"
            >
            
            <p>
                <span class="ml-2">Podjetje / organizcija:</span>
                <span class="ml-2 font-weight-bold">{{ itemData.name }}</span>
            </p>

            <p>
                <span class="ml-2">Omejitev parkiranja:</span>
                <span class="ml-2 font-weight-bold">{{ (itemData.parking_restriction) ? 'DA' : 'NE' }}</span>
            </p>

            <p>
                <span class="ml-2">Parkirna mesta:</span>
                <span class="ml-2 font-weight-bold">{{ (itemData.number_of_parking_spaces)}}</span>
            </p>


            <p>
                <span class="ml-2">Zasedenost parkirišč:</span>
                <!--<span class="ml-2 font-weight-bold">{{ (itemData.occupancy + "% (" + itemData.number_of_parking_spaces + "/" + itemData.occupied_parking_spaces + ")")}}</span>-->
                <span class="ml-2 font-weight-bold">{{ (itemData.occupancy + "% (" + itemData.occupied_parking_spaces + "/" + itemData.number_of_parking_spaces + ")")}}</span>
            </p>

            <p>
                <span class="ml-2">Število vseh uporabnikov:</span>
                <span class="ml-2 font-weight-bold">{{ itemData.company_users }}</span>
            </p>

            <!--
            <p>
                <span class="ml-2">Število aktivnih uporabnikov:</span>
                <span class="ml-2 font-weight-bold">{{ itemData.company_users_active }}</span>
            </p>
            -->

            <p>
                <span class="ml-2">Število vseh vpisanih registrskih številk:</span>
                <span class="ml-2 font-weight-bold">{{ itemData.registration_numbers_used }}</span>
            </p>

            <!--
            <p>
                <span class="ml-2">Število vpisanih registrskih številk (trenutno aktivnih):</span>
                <span class="ml-2 font-weight-bold">{{ itemData.registration_numbers_used_active }}</span>
            </p>
            -->

            <p>
                <span class="ml-2">Registrskih številk na voljo za vpis:</span>
                <span class="ml-2 font-weight-bold">{{ itemData.registration_numbers_available }}</span>
            </p>

            
        </v-alert>
        
    </div>
</template>

<script>

export default {
    name: 'parking-restrictions',
    data: () => ({
        interval1: null,
        itemData: null
    }),

    watch: {
        itemData(value) {
            //window.console.log(value)
        }
    },

    computed: {
        alertColor() {
            if(this.itemData) {
                if(this.itemData.registration_numbers_available > 0) {
                    return "success"
                }

                return "error"
            }

            return "info"
        }
    },

    methods: {
        fetchRestrictions() {
            this.$store.commit('SET_PROGRESS', true)
            this.$store.dispatch('PARKING_RESTRICTIONS')
            .then(response => {
                //console.log(response.data)
                if(response.data.length > 0) {
                    this.itemData = response.data[0]
                }
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() =>  {
                this.$store.commit('SET_PROGRESS', false)
            })  
        }
    },

    created() {
        //window.console.log("xxx");
        this.fetchRestrictions();
    },

    mounted() {
        this.interval1 = setInterval(() => {
            this.fetchRestrictions();
        }, 120000);
    },

    beforeDestroy() {
        clearInterval(this.interval1);
    }
}

</script>

<style scoped>
    
</style>